import { CommonModule as NgCommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabsModule } from 'primeng/tabs';
import { LabelControl } from '../directives/formcontrol-label.directive';
import { OrderByPipe } from '../pipes/order-by.pipe';
import { AppTableModule } from '../shared/components/app-table/app-table.module';
import { SharedModule } from '../shared/shared.module';
import { AnalysResultatComponent } from './analys-resultat/analys-resultat.component';
import { AntibioticCalcComponent } from './analys-resultat/antibiotic-calc/antibiotic-calc.component';
import { GeneralSearchComponent } from './analys-resultat/general-search/general-search.component';
import { NamnardataSearchComponent } from './analys-resultat/namnardata-search/namnardata-search.component';
import { SearchFormComponent } from './analys-resultat/search-form/search-form.component';
import { SearchParamsComponent } from './analys-resultat/search-params/search-params.component';
import { SearchResultListComponent } from './analys-resultat/specific-search-result-list/search-result-list.component';
import { SpecificSpeciesSearchComponent } from './analys-resultat/specific-species-search/specific-species-search.component';
import { AnvandareComponent } from './anvandare/anvandare.component';
import { EditAnvandareComponent } from './anvandare/edit-anvandare/edit-anvandare.component';
import { AtgardaEditDialogComponent } from './atgards-lista/atgarda-edit-dialog/atgarda-edit-dialog.component';
import { DuplicateDialogComponent } from './atgards-lista/atgarda-edit-dialog/duplicate-dialog/duplicate-dialog.components';
import { AtgardsListaComponent } from './atgards-lista/atgards-lista.component';
import { HistorikDialogComponent } from './atgards-lista/historik-dialog/historik-dialog.component';
import { IgnoreradeEditDialogComponent } from './ignorerade/ignorerade-edit-dialog/ignorerade-edit-dialog.component';
import { IgnoreradeComponent } from './ignorerade/ignorerade.component';
import { InskicksResultatComponent } from './inskicks-resultat/inskicks-resultat.component';
import { LaggaTillAnvandareComponent } from './lagga-till-anvandare/lagga-till-anvandare.component';
import { LarmHistorikComponent } from './larm-historik/larm-historik.component';
import { LarmKriteriumComponent } from './larm-kriterium/larm-kriterium.component';
import { NyttLarmKriteriumComponent } from './larm-kriterium/nytt-larm-kriterium/nytt-larm-kriterium.component';
import { LarmComponent } from './larm/larm.component';
import { StandardNamnComponent } from './standard-namn/standard-namn.component';
import { StartsidaComponent } from './startsida/startsida.component';
import { SynonymerEditDialogComponent } from './synonymer/synonymer-edit-dialog/synonymer-edit-dialog.component';
import { SynonymerComponent } from './synonymer/synonymer.component';
import { StandardNamnEditDialogComponent } from './standard-namn/standard-namn-edit-dialog/standard-namn-edit-dialog.component';
import { AddAnvandareOrganisationComponent } from './anvandare/edit-anvandare/add-anvandare-organisation/add-anvandare-organisation.component';
import { ConfirmRemoveOrganisationComponent } from './anvandare/edit-anvandare/confirm-remove-organisation/confirm-remove-organisation.component';
import { CaseSpellingDialogComponent } from './atgards-lista/atgarda-edit-dialog/case-spelling-dialog/case-spelling-dialog.component';

@NgModule({
  declarations: [
    AnalysResultatComponent,
    AtgardsListaComponent,
    StartsidaComponent,
    LarmComponent,
    SynonymerComponent,
    StandardNamnComponent,
    IgnoreradeComponent,
    AnvandareComponent,
    LaggaTillAnvandareComponent,
    InskicksResultatComponent,
    LarmKriteriumComponent,
    LarmHistorikComponent,
    SynonymerEditDialogComponent,
    IgnoreradeEditDialogComponent,
    AtgardaEditDialogComponent,
    HistorikDialogComponent,
    DuplicateDialogComponent,
    NyttLarmKriteriumComponent,
    EditAnvandareComponent,
    LabelControl,
    SpecificSpeciesSearchComponent,
    AntibioticCalcComponent,
    SearchResultListComponent,
    GeneralSearchComponent,
    SearchFormComponent,
    NamnardataSearchComponent,
    SearchParamsComponent,
    StandardNamnEditDialogComponent,
    AddAnvandareOrganisationComponent,
    ConfirmRemoveOrganisationComponent,
    CaseSpellingDialogComponent
  ],
  imports: [
    NgCommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MultiSelectModule,
    TabsModule,
    AppTableModule,
    OrderByPipe,
  ],
  exports: [
    AnalysResultatComponent,
    AtgardsListaComponent,
    StartsidaComponent,
    LarmComponent,
    SynonymerComponent,
    StandardNamnComponent,
    IgnoreradeComponent,
    AnvandareComponent,
    LaggaTillAnvandareComponent,
    InskicksResultatComponent,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [TitleCasePipe, OrderByPipe],
})
export class PagesModule {}
